'use client';
import { NetInfoState } from '@react-native-community/netinfo';
import NetInfo from '@react-native-community/netinfo';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

let _isConnected = true;

NetInfo.configure({
  reachabilityUrl: 'https://clients3.google.com/generate_204',
  reachabilityTest: async (response) => response.status === 204,
  reachabilityRequestTimeout: 5 * 1000, // 15s
  reachabilityShouldRun: () => Platform.OS !== 'web',
  useNativeReachability: true,
});

export const useConnection = () => {
  const [isConnected, setConnected] = useState(_isConnected);

  useEffect(() => {
    function handleConnectionChange(netInfo: NetInfoState) {
      _isConnected = (netInfo.isConnected && netInfo.isInternetReachable) ?? false;
      setConnected(_isConnected);
    }

    const subscriptionCancel = NetInfo.addEventListener(handleConnectionChange);
    return () => subscriptionCancel();
  }, []);

  return isConnected;
};

export const isNetworkAvailable = () => _isConnected;
